import { SecLoanApplicationType, SecLoanPurposeType } from '@shared/sec-loans'

export const getLoanPurposeTypes = (loanType: SecLoanApplicationType | undefined): SecLoanPurposeType[] => {
  if (!loanType) {
    return []
  }
  const allLoanPurposesExceptOther = Object.values(SecLoanPurposeType).filter(
    (purpose) => purpose !== SecLoanPurposeType.Other,
  )
  const buyAndTransfer = [SecLoanPurposeType.Buy, SecLoanPurposeType.LoanTransferToSbank]
  const loanTypes: Record<SecLoanApplicationType, SecLoanPurposeType[]> = {
    [SecLoanApplicationType.HousingLoan]: allLoanPurposesExceptOther,
    [SecLoanApplicationType.CottageLoan]: buyAndTransfer,
    [SecLoanApplicationType.PropertyInvestment]: buyAndTransfer,
    [SecLoanApplicationType.PurchaseLoan]: [SecLoanPurposeType.LoanTransferToSbank, SecLoanPurposeType.Other],
  }
  return loanTypes[loanType]
}
